export default __webpack_public_path__ + "static/media/AIPStatusLAP.ab9ead31.png";